<div class='application-details' *ngIf='application() as application'>
  <div class='row'>
    <div class='col-md-3'>
      <app-label label='Data utworzenia:'>
        {{ application?.createdAt | date }}
      </app-label>
    </div>
    <div class='col-md-3'>
      <app-label label='Data zatwierdzenia:'>
        {{ application?.updatedAt | date }}
      </app-label>
    </div>
    <div class='col-md-6'>
      <app-label label='Numer sprawy:'>
        {{ application?.caseNumber }}
      </app-label>
    </div>
  </div>
  <ng-container *ngIf='shipments()?.length'>
    <br>
    <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
    </app-decision-data-preview>
    <br>
  </ng-container>
  <app-applicant-preview
    [application]="application"
    [expanded]="expanded">
  </app-applicant-preview>
  <br>
  <h3>
    Dane wniosku
  </h3>
  <app-application-data-preview [application]="application">
  </app-application-data-preview>
  <br>
  <h3>
    Inwestor
  </h3>
  <app-contractor-data-preview [application]="application">
  </app-contractor-data-preview>
  <br>
  <h3>
    Zajęcia
  </h3>
  @if (roadOccupation(); as roadOccupation) {
    <app-occupation-preview
      [application]="application"
      [occupation]='roadOccupation'>
    </app-occupation-preview>
  }
  <br>
  <h3>
    Prognozowane opłaty
  </h3>
  <app-payments-data-preview
    [application]="application"
    [expanded]="expanded"
    [payment]="payment()">
  </app-payments-data-preview>
  <h3>
    Zgody
  </h3>
  <app-agreements-data-preview [application]="application">
  </app-agreements-data-preview>
  <br>
  <h3>
    Załączniki
  </h3>
  <app-attachments-data-preview [application]="application">
  </app-attachments-data-preview>
</div>
